import { Subject } from 'rxjs';
import Vue from 'vue';

export const indexedDBSubject = new Subject();

Vue.prototype.indexedDBSubject = indexedDBSubject;

